export const draftConst = {
  UPDATE_AD_GROUP_DRAFT: 'UPDATE_AD_GROUP_DRAFT',
  UPDATE_KEYWORDS_DRAFT: 'UPDATE_KEYWORDS_DRAFT',
  UPDATE_NEW_FEATURES_DRAFT: 'UPDATE_NEW_FEATURES_DRAFT',
};
